import { publicApi } from '../api';

const API_PROFILE_SIGNUP_PATH = '/profile/signup';

export const signup = async ({ password, email, phoneNumber, nickname }) => publicApi.post(
	`${API_PROFILE_SIGNUP_PATH}`,
	{ password, email, phoneNumber, nickname },
);
